import { VerificationService } from '@sheerid/jslib';
import { VerificationResult } from '../types/types';
import { getQueryParamsByName } from './browser';

export const getRedirectUrl = (verificationService: VerificationService, verificationResult: VerificationResult): string => {
    const redirectBaseUrl = decodeURIComponent(getQueryParamsByName('redirect_url'));
    const verificationId = verificationService.verificationResponse.verificationId;

    let redirect;
    if (redirectBaseUrl.includes('?')) {
        redirect = `${redirectBaseUrl}&verification_id=${verificationId}&verification_result=${verificationResult}`;
    } else {
        redirect = `${redirectBaseUrl}?verification_id=${verificationId}&verification_result=${verificationResult}`;
    }
    return redirect;
};
